import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { CommonService } from '../../frontend-services/common.service';


@Component({
  selector: 'alert-box',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertMessageComponent {
  @ViewChild('alertModel') alertModel: ModalDirective;
  alertModelMessage: any;

  constructor(private service:CommonService) { 
    
  }
  ngOnInit() {
    this.service.alert$.subscribe(message=>{
      if(message&&this.alertModel&&message!=this.alertModelMessage)
      {
        this.alert(message);
      }
    })
  }
  alert(message:any){
    if(!this.alertModel.isShown){
      this.alertModelMessage=message;
      this.alertModel.show();
    }
  }
  onAlertBoxClose(){
    this.alertModelMessage='';
    this.service.alert("");
    this.alertModel.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/alert/alert.component.ts